var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wizard-container"},[_c('div',{staticClass:"w-element options"},[_c('main-component',{ref:"main",attrs:{"contact":""}})],1),_vm._v(" "),_c('div',{staticClass:"w-element form"},[_c('form-component',{attrs:{"contact":""},on:{"reset":_vm.reset}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }